import { render, staticRenderFns } from "./AddPatientSurgeryInfo.vue?vue&type=template&id=cbc53c66&scoped=true"
import script from "./AddPatientSurgeryInfo.vue?vue&type=script&lang=js"
export * from "./AddPatientSurgeryInfo.vue?vue&type=script&lang=js"
import style0 from "./AddPatientSurgeryInfo.vue?vue&type=style&index=0&id=cbc53c66&prod&scoped=true&lang=css"
import style1 from "./AddPatientSurgeryInfo.vue?vue&type=style&index=1&id=cbc53c66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc53c66",
  null
  
)

export default component.exports